import { render, staticRenderFns } from "./GenericQr.vue?vue&type=template&id=b771887e&"
import script from "./GenericQr.vue?vue&type=script&lang=js&"
export * from "./GenericQr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports